module.exports = __webpack_public_path__ + "static/chinois-c1ee51a8258d2040eced7a40dd8af5e5.png";